import { render, staticRenderFns } from "./WaiterServicePlanTab.vue?vue&type=template&id=9e72749c&scoped=true&lang=pug"
import script from "./WaiterServicePlanTab.vue?vue&type=script&lang=ts"
export * from "./WaiterServicePlanTab.vue?vue&type=script&lang=ts"
import style0 from "./WaiterServicePlanTab.vue?vue&type=style&index=0&id=9e72749c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e72749c",
  null
  
)

export default component.exports